import { FiscalDetail } from '../../types';
import { DataGridHandler } from '../DataGridFlexSales';
import StatusCell from '../StatusCell';

export interface MastersStatusDataGridContext {
  t: (key: string | string[]) => string;
}

const initialContext: MastersStatusDataGridContext = {
  t: () => '',
};

export default (locale: Locale) => {
  const handler = new DataGridHandler<FiscalDetail, MastersStatusDataGridContext>(
    initialContext,
    locale
  );

  handler.addColumn({
    accessor: 'authorizationDate',
    type: 'date',
    title: ({ t }) => t('fiscal-detail.columns.authorizationDate'),
  });

  handler.addColumn({
    accessor: 'country',
    type: 'string',
    title: ({ t }) => t('masters-imports.columns.country'),
  });

  handler.addColumn({
    accessor: 'store',
    type: 'string',
    title: ({ t }) => t('masters-imports.columns.store'),
  });

  handler.addColumn({
    accessor: 'fiscalId',
    type: 'string',
    title: ({ t }) => t('masters-imports.columns.fiscalId'),
  });

  handler.addColumn({
    accessor: 'model',
    type: 'string',
    title: ({ t }) => t('fiscal-detail.columns.model'),
  });

  handler.addColumn({
    accessor: 'registry_qty',
    type: 'number',
    title: ({ t }) => t('fiscal-detail.columns.registry-qty'),
  });

  handler.addColumn({
    name: 'status',
    type: 'string',
    title: ({ t }) => t('masters-imports.columns.state'),
    width: { px: 200, pt: 400 },
    valueGetter: row => row.status,
    renderCell: (_value, row) => <StatusCell status={row.status} />,
  });

  return handler;
};
